import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function GetNewOTP(clientUuid, deviceUuids) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( 'provider/client/device/otp/' + clientUuid, {
            method: 'POST',
            headers: { 'Authorization' : unHashedJwt.data},
            data: {
                "deviceUuids": [deviceUuids]
            }      
        }).then(
            res => (res)
        ).catch(error => error.response.data),
        "Admin"
    )
}